export class PromoCodeRemoveError extends Error {
    constructor(message: string = 'Промокод не был применен') {
        super(message);
        this.name = 'PromoCodeRemoveError';
    }
}
